import filters from './filters';

export default function* () {
    yield* [
        ...filters,
    ];
}